import React from 'react';
import Avatar from '@mui/material/Avatar';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ColoredUserAvatar from '../../ColoredUserAvatar';

/**
 * Contact initials (WhatsApp gives no photo) in the name's own color, so the
 * same contact keeps its color everywhere; a person icon when there is no name.
 */
export default function ContactAvatar({ name, size = 40, sx }) {
  const sizeSx = { width: size, height: size, fontSize: size * 0.4, ...sx };

  if (!name?.trim()) {
    return (
      <Avatar sx={sizeSx}>
        <PersonOutlineIcon fontSize="small" />
      </Avatar>
    );
  }
  return <ColoredUserAvatar name={name.trim()} sx={sizeSx} />;
}
